module.exports = __webpack_public_path__ + "static/img/index_newsideNav_code2.ffde69e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_newsideNav_code2.png
// module id = Z+DI
// module chunks = 1